module.exports = __webpack_public_path__ + "static/media/356.fce3d1d3.png";